import { FC } from "react";
import { Card, Text, Table, Badge } from "@mantine/core";
import { useStyles } from "../Regtank.styles";
import { getRegtankColor } from "../../../../Utils/getRegtankDetails";
import type { RegtankData, RegtankLivenessData } from "../Regtank.types";
import { RegtankLivenessFHStatusEnum } from "@funded-here-interface/common/src/constant/enum";

interface UserDataCardProps {
  userData: RegtankData | RegtankLivenessData;
  type: "onboarding" | "liveness";
}

/**
 * Displays user information card with verification status
 * Reusable for both onboarding and liveness modals
 */
export const UserDataCard: FC<UserDataCardProps> = ({ userData, type }) => {
  const { classes } = useStyles();

  const isOnboarding = type === "onboarding";
  const onboardingData = isOnboarding ? (userData as RegtankData) : null;
  const livenessData = !isOnboarding ? (userData as RegtankLivenessData) : null;

  return (
    <Card
      withBorder
      shadow="sm"
      radius="md"
      className={classes.card}
      padding="md"
    >
      <Card.Section inheritPadding py="xs">
        <Text className={classes.subtext}>{userData.name}</Text>
        <Text className={classes.subSmallText}>{userData.userRole}</Text>
        <Text className={classes.subSmallText}>{userData.email}</Text>
      </Card.Section>
      <Card.Section inheritPadding py="xs">
        <Table withBorder withColumnBorders>
          <thead>
            <tr>
              <th className={classes.th}>Latest Status</th>
              <th className={classes.th}>Last Attempt On</th>
              {isOnboarding && <th className={classes.th}>Attempt Used</th>}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={classes.td}>
                {isOnboarding && onboardingData?.onboardingStatus && (
                  <Badge color={getRegtankColor(onboardingData.onboardingStatus)}>
                    {onboardingData.onboardingStatus}
                  </Badge>
                )}
                {!isOnboarding &&
                  livenessData?.verificationStatus &&
                  livenessData.verificationStatus !==
                    RegtankLivenessFHStatusEnum.NOTHING && (
                    <Badge
                      color={getRegtankColor(livenessData.verificationStatus)}
                    >
                      {livenessData.verificationStatus}
                    </Badge>
                  )}
              </td>
              <td className={classes.td}>{userData.lastAttemptDate}</td>
              {isOnboarding && (
                <td className={classes.td}>{onboardingData?.attemptUsed}</td>
              )}
            </tr>
          </tbody>
        </Table>
      </Card.Section>
    </Card>
  );
};